import { init } from "@sentry/browser";
import { CaptureConsole } from "@sentry/integrations";

/************ START: monkey patch Promise.reject*************/
const originalReject = Promise.reject.bind(Promise);
Promise.reject = function (reason) {
  if (typeof reason === "number") {
    console.error("Promise.reject() called with number:", reason, new Error().stack);
  }
  return originalReject(reason);
};
/************ END: monkey patch Promise.reject*************/

if (import.meta.env.PROD) {
  const environment =
    {
      "https://go.alvarum.com/": "production",
      "https://go.preprod.alvarum.com/": "preprod",
    }[localStorage.getItem("baseUrl") || import.meta.env.VITE_VUE_APP_API_BASE_PATH] || "dev";

  document.addEventListener(
    "deviceready",
    function () {
      window.cordova.require("sentry-cordova.Sentry").init({
        dsn: "https://3c0df38e003214c4883c61c03373870c@o4511699948929024.ingest.de.sentry.io/4511700068270160",
        release: import.meta.env.VITE_VUE_APP_RELEASE,
        environment,
        ignoreErrors: ["Network Error", "AppError"],
        integrations: [
          new CaptureConsole({
            levels: ["error"],
          }),
        ],
      });
    },
    true
  );
  init({
    dsn: "https://3c0df38e003214c4883c61c03373870c@o4511699948929024.ingest.de.sentry.io/4511700068270160",
    release: import.meta.env.VITE_VUE_APP_RELEASE,
    environment: import.meta.env.VITE_GIT_BRANCH || "production",
    ignoreErrors: ["Network Error", "AppError"],
    integrations: [
      // @ts-ignore
      new CaptureConsole({
        levels: ["error"],
      }),
    ],
  });
}
